import type { Os } from './types';

/**
 * OS names are proper product nouns and are not translated.
 */
export const OS_LABELS: Record<Os, string> = {
	macos: 'macOS',
	linux: 'Linux',
	windows: 'Windows',
};

export const OS_OPTIONS: Os[] = ['macos', 'linux', 'windows'];

/**
 * Best-effort detection of the user's OS from the browser. Falls back to
 * `'macos'` when running on the server or when no signal is available, so
 * server-rendered markup is stable and the value is refined on mount.
 */
export const detectOs = (): Os => {
	if (typeof navigator === 'undefined') {
		return 'macos';
	}
	const ua = `${navigator.userAgent} ${navigator.platform ?? ''}`.toLowerCase();
	if (ua.includes('win')) {
		return 'windows';
	}
	if (ua.includes('mac') || ua.includes('iphone') || ua.includes('ipad')) {
		return 'macos';
	}
	if (ua.includes('linux') || ua.includes('android') || ua.includes('cros')) {
		return 'linux';
	}
	return 'macos';
};
